__turbopack_context__.v({
  "list": "MobileMenuList-module__PDIqoa__list",
});
